module.exports = __webpack_public_path__ + "img/Mask group.cdd1464d.svg";